(function() {
  const checkFile = $fileInput => {
    const $inputWrapper = $fileInput.closest('.wpcf7-form-control-wrap');

    $inputWrapper.attr('data-value', 'Upload');

    $fileInput.on('change', event => {
      const $current = $(event.currentTarget);

      let filename =
        (event.currentTarget.files &&
          event.currentTarget.files[0] &&
          event.currentTarget.files[0].name) ||
        'Upload';

      if (filename.length > 12) {
        filename = '...' + filename.slice(-12, filename.length);
      }

      $current.closest('.wpcf7-form-control-wrap').attr('data-value', filename);
    });
  };

  checkFile($('.form-apply .input-file-custom'));

  /**
   * Scroll to Apply Form
   */
  $('.single-position__actions .btn').on('click', event => {
    const $target = $($(event.currentTarget).attr('href'));

    if ($target.length === 0) {
      return;
    }

    event.preventDefault();

    $('html, body').animate(
      {
        scrollTop: $target.offset().top - $('.header').outerHeight() - 40,
      },
      700
    );
  });
})();



// WEBPACK FOOTER //
// ./scripts/blocks/apply-form.js